import React from 'react'

const FormLauncher = (props) => {
    const { dynamicViewKey, viewMap, viewData, viewSwitcher, 
        compositionKey, pushFormObject, formObject, ...restProps } = props;

    let formData = null;
    let isGroupView = 0;

    // console.log("Debug_3", viewMap, viewData);

    if(viewData && viewData.viewType === "c"){
        if(compositionKey){
            formData = viewData.childViews[compositionKey];
        }
        else{
            formData = viewData;
            isGroupView = 1;
        }
    }
    else if(viewData && viewData.viewType !== "c"){
        formData = viewData;
    }

    //console.log("form api request form data", formData, restProps.dynamicViewData);

    const getDynamicView = (viewKey) => {
        // console.log("debug 1", viewKey, viewMap);

        let DynamicComponent = viewMap[viewKey];

        // console.log("debug 2", viewKey, viewMap);

        //TODO if view not found in the current module view map than search for it in cmn controls view map

        if(!DynamicComponent)
        {
            return null;
        }
        else
        {
            return DynamicComponent;
        }
    }

    if (formData) {
        const DynamicComponent = getDynamicView(formData.viewKey || dynamicViewKey);

        if (DynamicComponent) {

            if (isGroupView === 1) {
                return (
                    <DynamicComponent {...restProps} triggerType="custom"
                        viewSwitcher={viewSwitcher} viewMap={viewMap} viewData={formData} />
                )
            }
            else {
                if (pushFormObject && pushFormObject === 1) {
                    return (
                        <DynamicComponent {...restProps} formObject={formObject}
                            viewSwitcher={viewSwitcher} viewMap={viewMap} viewData={formData} />
                    )
                }

                return (
                    <DynamicComponent {...restProps}
                        viewSwitcher={viewSwitcher} viewMap={viewMap} viewData={formData} />
                )
            }
        }
    }

    return(null);
}

export default FormLauncher